import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import DeleteSite from './DeleteSite';
import Loading from 'components/Loading';

function AssetStoreFooter({
  companyId,
  editMode,
  enterprise_id,
  toggleEditMode,
  disabledButton,
  invalid,
  handleSubmitEdit,
  selectedOption,
  setEditMode,
  siteName,
  sudoSiteId,
  loadingSubmit,
  tooltipDescription,
  cancelEnabled,
}) {

  return (
    <div className="w-100 d-flex justify-content-between align-items-center">
      <div className='d-flex flex-row align-items-center'>
        {(selectedOption === "Site Details" && editMode) ?
          <DeleteSite 
            companyId={companyId} 
            sudoSiteId={sudoSiteId} 
            siteName={siteName} 
            enterprise_id={enterprise_id}
          />
        :
          <DeleteSite
            companyId={companyId} 
            sudoSiteId={sudoSiteId} 
            siteName={siteName} 
            enterprise_id={enterprise_id}
            deleteSiteDisabled={true}
          />
        }
      </div>
      {editMode &&
        <div className="d-flex align-items-center">
          {cancelEnabled &&
            <Button variant="danger" onClick={toggleEditMode} data-intercom-target={"asset-editor-cancel-submit-button"}>
              Cancel
            </Button>
          }
          <div className='ml-2'>
            {invalid
              ?
                <Tooltip
                    placement="top"
                    description={tooltipDescription ?? 
                      <ul className="m-0 pl-3 text-left">
                        {<li key={1}>required field(s) are empty</li>}
                      </ul>
                    }
                  >
                    <Button 
                      variant="success" 
                      className={invalid ? `${disabledButton}` : ""} 
                      data-intercom-target={"asset-editor-submit-button"}
                    >
                      Submit
                    </Button>
                  </Tooltip>
              :
                <Button 
                  variant="success"
                  onClick={handleSubmitEdit ?? (() => console.log("error: handle edit function is null"))}
                  data-intercom-target={"asset-editor-submit-button"}
                >
                  {loadingSubmit ? <Loading /> : "Submit"}
                </Button>
            }
          </div>
        </div>
      }
    </div>
  )
}

export default AssetStoreFooter
